// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ButtonAlt from '/react4xp/components/ButtonAlt'
import PositionBlock from '/react4xp/components/PositionBlock'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface ListVacanciesProps {
    tagline?: string
    title?: {
        hasPositions?: string
        noPositions?: string
    }
    positions?: Array<{
        title: string
        position: string
        details?: string
        link: string
        isExternal?: boolean
    }>
    bottomHeading?: string
    buttons?: Array<{
        text: string
        url: string
        external?: boolean
    }>
    noPositionsText?: string
    componentId?: string
}

export default function ListVacancies({
    tagline,
    title,
    bottomHeading,
    buttons,
    noPositionsText,
    positions,
    componentId
}: ListVacanciesProps) {
    return (
        <Section
            textColor='text-dark'
            className='list-vacancies'
            id={componentId}
        >
            <div className='grid-container'>
                <div className='grid-row'>
                    <div className={clsx(positions && positions.length >= 1 ? 'c-12' : 'c-md-10 start-md-2 c-lg-8 start-lg-3')}>
                
                        <div className='list-vacancies__header'>

                            {isNonWhitespaceString(tagline) && (
                                <p className='tagline-md tagline'>
                                    {tagline}
                                </p>
                            )}

                            {isNonWhitespaceString(title.hasPositions) && (
                                <h2 className='title-md title'>
                                    {positions && positions.length >= 1 ? title.hasPositions : title.noPositions}
                                </h2>
                            )}

                        </div>

                        {positions && positions.length >= 1 ? (
                            <div className='list-vacancies__positions'>
                                <div className='all-positions'>
                                    {positions.map((item, i) => (
                                        <PositionBlock
                                            key={i}
                                            href={item.link}
                                            isExternal={item.isExternal}
                                            title={item.title}
                                            position={item.position}
                                            details={item.details}
                                        />
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div
                                dangerouslySetInnerHTML={{ __html: noPositionsText }}
                                suppressHydrationWarning
                                className='text-md list-vacancies__no-positions'
                            />
                        )}
                        
                        {isNonWhitespaceString(bottomHeading) && (
                            <h3 className='title-sm list-vacancies__bottom-heading'>
                                {bottomHeading}
                            </h3>
                        )}

                        <div className='list-vacancies__bottom'>
                            {buttons.map((item, i) => (
                                <ButtonAlt
                                    text={item.text}
                                    href={item.url}
                                    target={item.external}
                                    key={i}
                                    iconRight="<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M4.24991 0.25H15.9999V12H13.9999V3.66421L2.24991 15.4142L0.835693 14L12.5857 2.25H4.24991V0.25Z'/></svg>"
                                />
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </Section>
    )
}

